import { accountsReceivableData } from "../../../locales/en";
import {
  FUNDED,
  OVERDUE,
  IN_DEFAULT,
  PROCESSING_LABEL,
  CLEARING,
  COMPLETED,
  FUNDED_STATUS_ID,
  OVERDUE_STATUS_ID,
  IN_DEFAULT_STATUS_ID,
  PROCESSING_STATUS_ID,
  CLEARING_STATUS_ID,
  COMPLETED_STATUS_ID
} from "../../../utils/constants/appConstants";

// The quote status id each filter option sends. The locale holds only the text; the names
// and ids live in appConstants beside the other status constants, and the set must stay in
// step with REPORTABLE_STATUS_IDS in the loan-management AccountsReceivableReportServiceImpl.
const STATUS_ID_BY_VALUE = {
  [FUNDED]: FUNDED_STATUS_ID,
  [OVERDUE]: OVERDUE_STATUS_ID,
  [IN_DEFAULT]: IN_DEFAULT_STATUS_ID,
  [PROCESSING_LABEL]: PROCESSING_STATUS_ID,
  [CLEARING]: CLEARING_STATUS_ID,
  [COMPLETED]: COMPLETED_STATUS_ID
};

/**
 * The status filter's options: the locale's text with the quote status id each option
 * sends mapped on. One list on purpose — the page seeds its selection from it and the
 * filter's dropdown renders it, so an option ticked in the dropdown always carries the
 * id the report request needs.
 */
export const statusOptions = accountsReceivableData.statusOptions.map(
  (option) => ({
    ...option,
    id: STATUS_ID_BY_VALUE[option.value]
  })
);
